export const EstimationsTabSearchPlaceholder = "Propriétaire, enseigne, raison sociale, activité, UUID...";

export async function getEstimationsSortingFilters(activities) {
  const result = [
    {
      id: 1,
      name: "Type",
      key: "type",
      visibleForNetworks: true,
      options: [
        {
          id: "1",
          description: "Fonds de commerce",
          selected: false,
        },
        {
          id: "2",
          description: "Titres de société",
          selected: false,
        },
        {
          id: "3",
          description: "Murs commerciaux",
          selected: false,
        },
      ],
    },
    {
      id: 2,
      name: "Activité",
      key: "activite",
      visibleForNetworks: true,
      options: activities.map(activity => ({
        id: activity.id + "",
        description: activity.description,
        selected: false,
      })),
    },
    {
      id: 3,
      name: "Archivage",
      key: "archived",
      visibleForNetworks: true,
      isUniqueValue: true,
      options: [
        {
          id: true,
          description: "Estimations archivées seulement",
          selected: false,
        },
        {
          id: false,
          description: "Estimation non archivées seulement",
          selected: false,
        },
        {
          id: "undefined",
          description: "Toutes les estimations",
          selected: true,
        },
      ],
    },
    {
      id: 4,
      name: "Etat",
      key: "validated",
      visibleForNetworks: true,
      isUniqueValue: true,
      options: [
        {
          id: true,
          description: "Estimations terminées seulement",
          selected: false,
        },
        {
          id: false,
          description: "Estimation non terminées seulement",
          selected: false,
        },
        {
          id: "undefined",
          description: "Toutes les estimations",
          selected: true,
        },
      ],
    },
  ];

  return result;
}

export function getEstimationsTabColumnClassName(key, value) {
  return "";
}
